import { Skeleton } from '@/shared/ui/primitives'

type AppShellSkeletonProps = {
  testId?: string
}

export function AppShellSkeleton({ testId = 'app-shell-skeleton' }: AppShellSkeletonProps) {
  return (
    <div data-testid={testId} className="flex h-dvh w-full bg-sidebar text-foreground">
      <aside className="hidden w-64 shrink-0 flex-col gap-6 border-r border-sidebar-border p-4 lg:flex">
        <Skeleton className="h-9 w-40" />
        <div className="flex flex-col gap-2">
          {Array.from({ length: 7 }).map((_, index) => (
            <Skeleton key={index} className="h-8 w-full" />
          ))}
        </div>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-14 shrink-0 items-center justify-between px-4">
          <Skeleton className="h-6 w-44" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </header>
        <main className="min-h-0 flex-1 overflow-hidden lg:rounded-tl-xl lg:bg-background">
          <div className="flex flex-col gap-4 p-6">
            <Skeleton className="h-8 w-64" />
            <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
              {Array.from({ length: 4 }).map((_, index) => (
                <Skeleton key={index} className="h-28 w-full" />
              ))}
            </div>
            <Skeleton className="h-72 w-full" />
          </div>
        </main>
      </div>
    </div>
  )
}
